import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const PrintIcon = ({ label = 'Print', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path style="fill:#85cee3" d="M187 50.5H82.7v73.8h132.8V79L187 50.5z"/><path d="M187 50.5 215.5 79v45.3H82.7V50.5H187m0-10H82.7a10 10 0 0 0-10 10v73.8a10 10 0 0 0 10 10h132.8a10 10 0 0 0 10-10V79a10 10 0 0 0-3-7.1L194 43.4a9.7 9.7 0 0 0-7-2.9z" style="fill:#1d1d1b"/><path style="fill:#85cee3" d="M82.7 214.3h132.7v39.62H82.7z"/><path d="M215.5 214.3v39.6H82.7v-39.6h132.8m0-10H82.7a10 10 0 0 0-10 10v39.6a10 10 0 0 0 10 10h132.8a10 10 0 0 0 10-10v-39.6a10 10 0 0 0-10-10z" style="fill:#1d1d1b"/><path d="M249.6 206.8v-61.3a14 14 0 0 0-4.2-10.1 13.8 13.8 0 0 0-10-4.2H62.8a13.8 13.8 0 0 0-10 4.2 14 14 0 0 0-4.2 10.1v61.3z" style="fill:#85cee3"/><path d="M235.4 131.2a13.8 13.8 0 0 1 10 4.2 14 14 0 0 1 4.2 10.1v61.3h-201v-61.3a14 14 0 0 1 4.2-10.1 13.8 13.8 0 0 1 10-4.2h172.6m0-10H62.8a23.8 23.8 0 0 0-17.1 7.2 23.5 23.5 0 0 0-7.1 17.1v61.3a10 10 0 0 0 10 10h201a10 10 0 0 0 10-10v-61.3a24.4 24.4 0 0 0-24.2-24.3zm-98.8-11.8a5.5 5.5 0 0 1-5.5-5.4V73.4a5.5 5.5 0 0 1 5.5-5.5 5.5 5.5 0 0 1 5.4 5.5V104a5.4 5.4 0 0 1-5.4 5.4z" style="fill:#1d1d1b"/><path d="M194.3 43.2a6.8 6.8 0 0 0-6.8 6.9v21.5a6.8 6.8 0 0 0 6.8 6.9h21.5a6.9 6.9 0 0 0 6.9-6.9" style="fill-rule:evenodd;fill:#1d1d1b"/><path d="M214.2 155a10.3 10.3 0 0 1 7.6 3.1 10.4 10.4 0 0 1 3.1 7.5 10.7 10.7 0 0 1-3.1 7.6 10.7 10.7 0 0 1-18.3-7.6 10 10 0 0 1 3.1-7.5 10.3 10.3 0 0 1 7.6-3.1z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

PrintIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { PrintIcon }
